import { Box, Card, Grid, Text } from '@factorialco/deprecated-design-system'
import { EmployeeViewCostHistoryDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'
import i18n from 'modules/core/lib/i18n'

import { LoadingState } from 'modules/project_management/components/LoadingState'

import CostHistoryRecords from '../CostHistoryRecords'
import { InsightCard } from '../InsightCard'

interface IEmployeeCostHistory {
  projectWorkerIds: number[]
  employeeInputedMinutes: number
  employeeLaborCostCents: number
  employeeLegalEntityCurrency: string
}

const EmployeeCostHistory = ({
  employeeInputedMinutes,
  employeeLaborCostCents,
  employeeLegalEntityCurrency,
  projectWorkerIds,
}: IEmployeeCostHistory) => {
  const { data, loading: loadingCostHistoryRecords } = useQuery(EmployeeViewCostHistoryDocument, {
    variables: {
      projectWorkerIds,
    },
  })
  const costHistoryRecords = data?.projectManagement.projectWorkersCostHistoryRecords || []

  return (
    <Card>
      <Card.Content>
        <Box paddingBottom="s16">
          <Text color="grey1000" size="400" ellipsis whiteSpace="nowrap" weight="medium">
            {i18n.t('project_management.project_workers.details.cost_history')}
          </Text>
        </Box>
        <Grid variant="fixed">
          <Box gridColSpan={{ xxs: 12, s: 6 }}>
            <Box gap="s16">
              <Box width="full">
                <InsightCard.Hours
                  icon="clock"
                  imputedMinutes={employeeInputedMinutes}
                  title={i18n.t('project_management.project_workers.details.registered_hours')}
                  titleGap="s2"
                />
              </Box>
              <Box width="full">
                <InsightCard.Cost
                  icon="dollar-bill"
                  totalCost={employeeLaborCostCents}
                  currency={'eur'}
                  title={i18n.t('project_management.project_workers.details.labor_cost')}
                  titleGap="s2"
                />
              </Box>
            </Box>
          </Box>
          <Box gridColSpan={{ xxs: 12, s: 6 }}>
            {loadingCostHistoryRecords ? (
              <LoadingState />
            ) : (
              <Box flexDirection="row" width="full">
                <CostHistoryRecords
                  costHistoryRecords={costHistoryRecords}
                  laborCostCurrency={employeeLegalEntityCurrency}
                />
              </Box>
            )}
          </Box>
        </Grid>
      </Card.Content>
    </Card>
  )
}

export default EmployeeCostHistory
